import React from 'react';
import styles from './index.less';
// eslint-disable-next-line react/display-name
export default ({ overrideStyle = {} }) => (
  <div className={styles.footer} style={overrideStyle}>
    Conviva Pulse&nbsp;
    <a href="https://pulse.conviva.com/legal/#terms" target="_blank" rel="noopener noreferrer">Terms/AUP</a>
    &nbsp;&copy;
    {(new Date()).getFullYear()}
    Conviva. All rights reserved.
  </div>
);
